export const CHANGE_PHARMACY = 'CHANGE_PHARMACY';
export const SET_USER = 'SET_USER';
export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN';
export const SET_NOTICE = 'SET_NOTICE';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const SET_SEARCH_FILTERS = 'SET_SEARCH_FILTERS';
export const LOGOUT = 'LOGOUT';
export const SET_TEMPLATES = 'SET_TEMPLATES';